<template>
  <page-layout title="Profile" linkDefault="/" :backButton="true" :chatt="!!user"
    @chat="() => {
      if (!!user) this.$router.push(`/chats/${user._id}:${this.$store.state.user._id}:`)
    }" :key="changeUser">
    <Loading v-if="!(user && user2)" />
    <div v-else>
      <div class="flex flex-row items-start justify-start m-5 relative space-y-0 w-full">
        <div class="relative">
          <div class="absolute -my-1 z-30">
            <svg class="absolute " width="37" height="40" viewBox="0 0 33 36" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10.8573 24.1361C9.66732 21.9623 8.57338 20.5328 8.10337 18.9185C8.0844 18.8561 8.06607 18.791 8.04657 18.7182C8.21492 18.5571 8.32442 18.3442 8.35766 18.1136C8.3909 17.8829 8.34594 17.6477 8.22993 17.4456C8.1331 17.2929 7.99384 17.1717 7.82923 17.0969C7.88138 16.286 8.29228 15.6378 9.59789 15.8607C10.6141 16.0357 12.6352 19.1959 12.8936 20.5226C23.5922 9.79114 30.4912 8.65966 30.4912 8.65966C28.9837 8.2929 27.8122 6.62416 26.4741 5.55483C27.2579 4.53067 28.1082 3.5592 29.0196 2.64664C30.1082 1.75128 31.2434 0.914187 32.4205 0.138962C17.9445 -0.339522 10.2289 10.293 0.663765 17.8077C0.783863 18.064 0.899167 18.3221 1.02139 18.5818C2.96253 17.9731 4.89592 17.3658 6.82144 16.7599C6.92469 16.8439 7.02291 16.9275 7.12287 17.0101C6.98108 17.0414 6.84555 17.0963 6.72187 17.1723C6.47138 17.3128 6.28669 17.5468 6.20812 17.823C6.12955 18.0993 6.16349 18.3953 6.30255 18.6466C6.34629 18.7147 6.39915 18.7766 6.45971 18.8303C6.20699 19.1887 6.07194 19.6168 6.07323 20.0553C6.55574 24.6877 7.25094 29.2981 7.98181 33.9015C8.02192 34.185 8.10647 34.4605 8.23245 34.7176C8.27345 34.8037 8.32414 34.8848 8.38352 34.9594L9.06882 35.3294L9.67142 34.7841L10.0828 35.5707C10.3957 35.4993 10.6963 35.3818 10.9746 35.222L11.8664 34.3451C12.8905 30.9423 12.5278 27.2725 10.8573 24.1361Z"
                fill="#FF8303" />
            </svg>
          </div>
          <Avatar :user="user" size="large" class="gap-3" />
        </div>
        <div class="flex flex-col space-y-1.5">
          <div class="flex flex-row mx-2 items-center justify-between">
            <tag class="h-7 uppercase font-poppins" :text="user.university?.abbrev" :active="true"
              v-if="user.university?.abbrev">
            </tag>
          </div>
          <p class="heading-1 capitalize ml-1">{{ user.name }}</p>
          <div class="flex flex-row items-center ml-1">
            <tag class="font-poppins w-14" :text="TutorName" :color="true" :small="false">
            </tag>
            <tag class="font-poppins" :text="(rate + ' EGP')" :color="true" :small="false">
            </tag>
            <n-rate :size="10" readonly :default-value="parseInt(rating + 0.49)" />
          </div>
          <div class="flex flex-row items-center ml-1">
            <div class="flex flex-row items-center justify-center">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M9.89878 1.11701C10.0655 0.986613 10.2711 0.915771 10.4828 0.915771C10.6945 0.915771 10.9 0.986613 11.0668 1.11701L12.6358 2.35001L14.6138 2.07201C14.8234 2.04252 15.0369 2.08398 15.2203 2.1898C15.4037 2.29562 15.5464 2.45973 15.6258 2.65601L16.3738 4.50801L18.2258 5.25601C18.4222 5.33523 18.5864 5.47793 18.6922 5.66135C18.7981 5.84476 18.8394 6.05834 18.8098 6.26801L18.5318 8.24601L19.7618 9.82001C19.8922 9.98675 19.963 10.1923 19.963 10.404C19.963 10.6157 19.8922 10.8213 19.7618 10.988L18.5318 12.562L18.8098 14.54C18.8393 14.7497 18.7978 14.9632 18.692 15.1465C18.5862 15.3299 18.4221 15.4726 18.2258 15.552L16.3738 16.3L15.6258 18.152C15.5465 18.3484 15.4039 18.5126 15.2205 18.6185C15.037 18.7243 14.8235 18.7657 14.6138 18.736L12.6358 18.45L11.0618 19.68C10.895 19.8104 10.6895 19.8813 10.4778 19.8813C10.2661 19.8813 10.0605 19.8104 9.89378 19.68L8.31978 18.45L6.34177 18.728C6.13375 18.7567 5.9221 18.7155 5.74003 18.6109C5.55795 18.5063 5.41577 18.3442 5.33578 18.15L4.58778 16.298L2.73578 15.55C2.53939 15.4708 2.37518 15.3281 2.26933 15.1447C2.16349 14.9613 2.12211 14.7477 2.15178 14.538L2.42978 12.56L1.19978 10.986C1.06938 10.8193 0.998535 10.6137 0.998535 10.402C0.998535 10.1903 1.06938 9.98475 1.19978 9.81801L2.42978 8.24401L2.15178 6.26601C2.12133 6.05573 2.16233 5.84131 2.26822 5.6571C2.3741 5.47289 2.53875 5.32954 2.73578 5.25001L4.58778 4.50201L5.33578 2.65001C5.41514 2.45373 5.55787 2.28963 5.74125 2.1838C5.92463 2.07798 6.13812 2.03652 6.34778 2.06601L8.32578 2.34401L9.89878 1.11701ZM13.9988 9.17301C14.1766 8.99518 14.2765 8.754 14.2765 8.50251C14.2765 8.25102 14.1766 8.00984 13.9988 7.83201C13.9107 7.74396 13.8062 7.67411 13.6912 7.62646C13.5761 7.57881 13.4528 7.55428 13.3283 7.55428C13.0768 7.55428 12.8356 7.65418 12.6578 7.83201L9.53577 10.95L8.30978 9.72401C8.13195 9.54618 7.89076 9.44628 7.63927 9.44628C7.38779 9.44628 7.14661 9.54618 6.96878 9.72401C6.79095 9.90184 6.69105 10.143 6.69105 10.3945C6.69105 10.646 6.79095 10.8872 6.96878 11.065L8.86877 12.965C8.95681 13.0531 9.06134 13.123 9.17638 13.1706C9.29143 13.2183 9.41474 13.2428 9.53928 13.2428C9.66381 13.2428 9.78712 13.2183 9.90217 13.1706C10.0172 13.123 10.1217 13.0531 10.2098 12.965L13.9988 9.17301Z"
                  fill="#FE8303" />
              </svg>
              <span class="font-poppins text-xs leading-3 ml-1 mt-1">{{ approvesCount }} Approves</span>
            </div>

            <div class="flex flex-row items-center justify-center ml-8">

              <svg class="mt-1" width="12" height="12" viewBox="0 0 12 12" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.25238 11.1301C6.99146 11.0198 5.75646 10.7078 4.59442 10.2061C4.36342 10.1201 4.16342 10.0451 4.00842 9.99405C3.75472 9.94636 3.49611 9.92992 3.2384 9.94507H3.07141C2.9098 9.94481 2.75487 9.88042 2.64069 9.76606C2.52651 9.65169 2.4624 9.49667 2.4624 9.33506V4.68207C2.46256 4.52394 2.52401 4.372 2.63385 4.25824C2.74369 4.14449 2.89336 4.07775 3.05139 4.07206C3.13962 4.06605 3.22817 4.06605 3.31641 4.07206C3.43401 4.08068 3.55219 4.07869 3.66943 4.06607C3.72043 4.00307 3.8274 3.88306 4.0694 3.61606C4.4174 3.22806 5.20638 2.34906 5.36938 2.09006V1.48105C5.36913 1.363 5.39236 1.24607 5.43768 1.13706C5.483 1.02805 5.54954 0.92915 5.63342 0.846073C5.71786 0.761727 5.81812 0.694895 5.92847 0.649418C6.03881 0.603941 6.15708 0.580701 6.27643 0.581059H6.30939C6.65073 0.587468 6.98508 0.679125 7.28198 0.84766C7.57888 1.0162 7.82892 1.25626 8.0094 1.54606C8.19548 1.82412 8.30642 2.14561 8.33148 2.47925C8.35654 2.81289 8.29486 3.14734 8.1524 3.45008L8.1344 3.48706H9.29138C10.1308 4.34512 10.7901 5.36241 11.2304 6.47907L11.2474 6.48505V6.71506C11.2477 7.09874 11.1112 7.46996 10.8624 7.76206C10.9891 8.13608 10.9781 8.54303 10.8314 8.90967C10.6848 9.27632 10.412 9.57858 10.0624 9.76206C10.0443 9.9822 9.97538 10.1951 9.86102 10.3841C9.74667 10.5731 9.59001 10.7329 9.40338 10.8511C9.05308 11.0492 8.65452 11.1458 8.25238 11.1301V11.1301ZM3.42743 9.30506C3.69075 9.2943 3.95421 9.32227 4.20941 9.38807C4.37541 9.44407 4.58038 9.52007 4.81738 9.60807C5.99438 10.0461 8.18639 10.8621 9.06439 10.3171C9.17511 10.2432 9.26638 10.1438 9.33044 10.0271C9.39451 9.91049 9.42953 9.78011 9.43243 9.64707C9.44184 9.55334 9.47581 9.46375 9.53094 9.38736C9.58608 9.31098 9.6604 9.25051 9.7464 9.21207C9.97139 9.10199 10.1473 8.912 10.2397 8.6792C10.3322 8.44641 10.3346 8.18752 10.2464 7.95307C10.2067 7.85847 10.195 7.75445 10.2127 7.65339C10.2304 7.55232 10.2768 7.45848 10.3464 7.38306C10.51 7.20615 10.6026 6.97505 10.6064 6.73407V6.71805C10.6064 6.47189 10.5135 6.23477 10.3464 6.05405C10.2762 5.97858 10.2294 5.88439 10.2117 5.78287C10.1939 5.68135 10.206 5.57686 10.2464 5.48206C10.3027 5.33014 10.3214 5.16687 10.3009 5.00617C10.2804 4.84546 10.2214 4.6921 10.1289 4.55912C10.0364 4.42613 9.9131 4.31749 9.76953 4.24244C9.62597 4.16738 9.46638 4.12813 9.30438 4.12806H7.96442C7.87296 4.12818 7.78298 4.10492 7.70306 4.06046C7.62315 4.01599 7.55592 3.95181 7.50781 3.87403C7.4597 3.79625 7.43232 3.70746 7.42822 3.61609C7.42412 3.52473 7.44343 3.43383 7.48438 3.35205L7.55939 3.20307C7.56439 3.19207 7.57042 3.18206 7.57642 3.17206C7.67176 2.9679 7.71265 2.74256 7.69513 2.51792C7.67761 2.29327 7.60222 2.07699 7.47638 1.89008C7.35191 1.68638 7.17741 1.51788 6.96948 1.40061C6.76155 1.28334 6.52711 1.2212 6.28839 1.22007H6.2804C6.2446 1.21984 6.20915 1.22671 6.17603 1.24027C6.1429 1.25383 6.11276 1.27382 6.0874 1.29908C6.06303 1.32292 6.04368 1.35136 6.03046 1.38279C6.01723 1.41421 6.01038 1.44797 6.01038 1.48206V2.09305C6.01038 2.10505 6.01038 2.11606 6.01038 2.12806C6.02138 2.32806 5.95743 2.46306 4.53943 4.04306C4.36743 4.23406 4.19042 4.43205 4.15942 4.47205C4.13152 4.51243 4.09779 4.54851 4.05939 4.57908C3.82411 4.70727 3.5527 4.75304 3.28839 4.70908C3.22639 4.70908 3.14038 4.70308 3.11438 4.70908H3.1004V9.30906H3.42743V9.30506ZM5.37939 2.20505C5.38328 2.22562 5.38932 2.24576 5.3974 2.26508C5.39175 2.24612 5.38772 2.22671 5.38538 2.20707L5.37939 2.20505Z"
                  fill="black" />
                <path
                  d="M2.24518 9.89908H1.77917C1.55409 9.89881 1.3383 9.80928 1.17914 9.65012C1.01998 9.49095 0.93044 9.27517 0.930176 9.05008V4.95407C0.93044 4.72898 1.01998 4.5132 1.17914 4.35403C1.3383 4.19487 1.55409 4.10534 1.77917 4.10507H2.24518C2.47027 4.10534 2.68605 4.19487 2.84521 4.35403C3.00438 4.5132 3.09391 4.72898 3.09418 4.95407V9.05405C3.09286 9.27844 3.00286 9.49322 2.84381 9.65152C2.68476 9.80982 2.46958 9.89882 2.24518 9.89908ZM1.77917 4.74808C1.72321 4.74808 1.66958 4.77027 1.63 4.80984C1.59043 4.84942 1.56818 4.90312 1.56818 4.95908V9.05405C1.56818 9.11001 1.59043 9.16371 1.63 9.20328C1.66958 9.24285 1.72321 9.26505 1.77917 9.26505H2.24518C2.30097 9.26478 2.35438 9.24245 2.39374 9.20291C2.43309 9.16337 2.4552 9.10983 2.4552 9.05405V4.95407C2.4552 4.89828 2.43309 4.84475 2.39374 4.80521C2.35438 4.76566 2.30097 4.74334 2.24518 4.74307L1.77917 4.74808Z"
                  fill="black" />
              </svg>

              <span class="font-poppins text-xs leading-3 ml-1 mt-1">{{ likesCount }}</span>
            </div>


            <!-- <div class="flex flex-row items-center justify-center ml-5">
            <svg class="mt-1" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M3.92682 0.58392C5.18774 0.694194 6.42274 1.00617 7.58478 1.50793C7.81578 1.59393 8.01578 1.66894 8.17078 1.71994C8.42448 1.76763 8.68309 1.78407 8.9408 1.76892H9.10779C9.2694 1.76918 9.42433 1.83356 9.53851 1.94793C9.65269 2.0623 9.7168 2.21732 9.7168 2.37893L9.7168 7.03192C9.71664 7.19005 9.65519 7.34199 9.54535 7.45575C9.43551 7.5695 9.28584 7.63624 9.12781 7.64193C9.03958 7.64794 8.95102 7.64794 8.86279 7.64193C8.74519 7.63331 8.62701 7.6353 8.50977 7.64791C8.45877 7.71091 8.3518 7.83093 8.1098 8.09793C7.7618 8.48593 6.97281 9.36493 6.80981 9.62393V10.2329C6.81007 10.351 6.78684 10.4679 6.74152 10.5769C6.6962 10.6859 6.62965 10.7848 6.54578 10.8679C6.46134 10.9523 6.36108 11.0191 6.25073 11.0646C6.14039 11.11 6.02212 11.1333 5.90277 11.1329H5.86981C5.52847 11.1265 5.19412 11.0349 4.89722 10.8663C4.60032 10.6978 4.35028 10.4577 4.1698 10.1679C3.98372 9.88987 3.87278 9.56838 3.84772 9.23474C3.82266 8.9011 3.88433 8.56665 4.02679 8.26391L4.0448 8.22692H2.88782C2.04843 7.36887 1.38913 6.35158 0.948792 5.23492L0.931824 5.22894V4.99893C0.931548 4.61525 1.068 4.24403 1.31677 3.95193C1.1901 3.57791 1.20112 3.17096 1.34778 2.80432C1.49444 2.43767 1.76715 2.13541 2.11682 1.95193C2.13489 1.73179 2.20382 1.51886 2.31818 1.32989C2.43253 1.14092 2.58919 0.981046 2.77582 0.862911C3.12612 0.664789 3.52468 0.568186 3.92682 0.58392V0.58392ZM8.75177 2.40893C8.48845 2.41969 8.22499 2.39172 7.96979 2.32592C7.80379 2.26992 7.59882 2.19392 7.36182 2.10592C6.18482 1.66792 3.99281 0.851938 3.11481 1.39694C3.00409 1.47077 2.91282 1.57021 2.84875 1.68686C2.78469 1.8035 2.74967 1.93387 2.74677 2.06692C2.73736 2.16065 2.70339 2.25024 2.64825 2.32663C2.59312 2.40301 2.5188 2.46348 2.4328 2.50192C2.2078 2.612 2.03191 2.80199 1.93945 3.03479C1.847 3.26758 1.84463 3.52647 1.9328 3.76092C1.97255 3.85552 1.98422 3.95954 1.96649 4.0606C1.94876 4.16167 1.9024 4.25551 1.83282 4.33093C1.66915 4.50784 1.57655 4.73894 1.57281 4.97992V4.99594C1.57283 5.2421 1.66568 5.47921 1.83282 5.65994C1.90301 5.73541 1.94978 5.8296 1.96753 5.93112C1.98528 6.03264 1.97322 6.13712 1.9328 6.23193C1.87654 6.38385 1.85784 6.54712 1.8783 6.70782C1.89875 6.86852 1.95777 7.02189 2.05029 7.15487C2.14281 7.28786 2.2661 7.3965 2.40967 7.47155C2.55323 7.54661 2.71282 7.58586 2.87482 7.58593H4.21478C4.30624 7.58581 4.39622 7.60906 4.47614 7.65353C4.55605 7.698 4.62328 7.76218 4.67139 7.83996C4.7195 7.91774 4.74688 8.00653 4.75098 8.0979C4.75508 8.18926 4.73577 8.28016 4.69482 8.36193L4.61981 8.51092C4.61481 8.52192 4.60878 8.53193 4.60278 8.54193C4.50744 8.74609 4.46655 8.97143 4.48407 9.19607C4.50159 9.42071 4.57698 9.637 4.70282 9.82391C4.82729 10.0276 5.00179 10.1961 5.20972 10.3134C5.41765 10.4306 5.65209 10.4928 5.89081 10.4939H5.8988C5.9346 10.4942 5.97005 10.4873 6.00317 10.4737C6.0363 10.4602 6.06644 10.4402 6.0918 10.4149C6.11617 10.3911 6.13552 10.3626 6.14874 10.3312C6.16197 10.2998 6.16882 10.266 6.16882 10.2319V9.62094C6.16882 9.60894 6.16882 9.59793 6.16882 9.58593C6.15782 9.38593 6.22177 9.25092 7.63977 7.67092C7.81177 7.47992 7.98878 7.28194 8.01978 7.24194C8.04768 7.20156 8.08141 7.16548 8.11981 7.13491C8.35509 7.00672 8.6265 6.96095 8.89081 7.00491C8.95281 7.00491 9.03882 7.01091 9.06482 7.00491H9.0788L9.0788 2.40493H8.75177V2.40893ZM6.7998 9.50894C6.79591 9.48836 6.78988 9.46823 6.7818 9.44891C6.78744 9.46787 6.79148 9.48728 6.79382 9.50692L6.7998 9.50894Z"
                fill="black" />
              <path
                d="M9.93402 1.81491H10.4C10.6251 1.81518 10.8409 1.90471 11.0001 2.06387C11.1592 2.22303 11.2488 2.43882 11.249 2.66391V6.75992C11.2488 6.98501 11.1592 7.20079 11.0001 7.35995C10.8409 7.51912 10.6251 7.60865 10.4 7.60892H9.93402C9.70893 7.60865 9.49315 7.51912 9.33398 7.35995C9.17482 7.20079 9.08529 6.98501 9.08502 6.75992V2.65994C9.08634 2.43555 9.17634 2.22077 9.33539 2.06247C9.49444 1.90417 9.70962 1.81517 9.93402 1.81491ZM10.4 6.96591C10.456 6.96591 10.5096 6.94371 10.5492 6.90414C10.5888 6.86457 10.611 6.81087 10.611 6.75491V2.65994C10.611 2.60398 10.5888 2.55028 10.5492 2.51071C10.5096 2.47114 10.456 2.44894 10.4 2.44894H9.93402C9.87823 2.44921 9.82482 2.47154 9.78546 2.51108C9.74611 2.55062 9.724 2.60415 9.724 2.65994V6.75992C9.724 6.81571 9.74611 6.86924 9.78546 6.90878C9.82482 6.94832 9.87823 6.97065 9.93402 6.97092L10.4 6.96591Z"
                fill="black" />
            </svg>

            <span class="font-poppins text-xs leading-3 ml-1 mt-1">360</span>
          </div> -->
          </div>
        </div>
      </div>
      <div class="flex flex-col items-start w-80 justify-start mr-1 ml-8 mb-4">
        <p class="font-poppins font-semibold truncate  text-sm leading-6 align-middle">
          Bio
        </p>
        <p>{{ user.bio }}</p>
      </div>
      <hr />
      <div class="flex flex-col items-start justify-start mb-4 mr-1 ml-6 mt-6">
        <p class="font-poppins ml-2 font-semibold text-sm leading-6 align-middle mb-3 ">
          Classes they tutor in
        </p>
        <div class="flex flex-wrap">
          <FilterTag class="mb-2 mx-1" :key="i" v-for="(_class, i) in courses">{{ _class.class.name }} </FilterTag>
        </div>
      </div>

      <div class="flex flex-row items-center justify-start mb-4 mr-5 ml-8" v-if="posts?.length > 0">
        <p class="font-poppins font-semibold text-sm leading-6 align-middle">
          Recent Posts
        </p>
      </div>

      <div class="flex flex-col justify-center items-center ml-5 mr-7 mt-2 gap-y-5">
        <post v-for="(_post, i) in posts.filter(p => !p.is_anonymous)" :key="i" :post="{ ..._post, user: user2 }" />
      </div>
      <transition name="fade-up-left" appear>
        <button class="
            fixed
            right-5
           bottom-10
            bg-orange
            rounded-full
            px-8
            text-lg
            py-3
            text-white
            font-bold
            shadow-lg
            capitalize
          " @click="book()">
          Request a session
        </button>
      </transition>
    </div>
  </page-layout>
</template>

<script>
import Loading from "../../components/Loading.vue";
import Button from "../../components/Feed/Button.vue";
import Avatar from "../../components/Feed/Avatar.vue";
import FilterTag from "../../components/Feed/FilterTag.vue";
import ClassCard from "../../components/Feed/ClassCard.vue";
import Post from "../../components/Feed/Post.vue";
import pageLayout from "../../components/base/pageLayout.vue";
import { getUser } from "../../helpers/API/Core/User";
import { GetPostsByUsername } from '../../helpers/API/Feeds/Post';
import { getTutor } from '../../helpers/API/Core/Tutor'
import tag from '../../components/tag.vue';
import { NRate } from "naive-ui";
import { getProfileByUsername } from '../../helpers/API/Feeds/User'

import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
import mixpanel from "mixpanel-browser";
import { readFromLocalStorage } from "../../helpers";
export default {
  components: { Button, Avatar, FilterTag, ClassCard, Post, pageLayout, Loading, tag, NRate },
  data() {
    return {
      user: null,
      tutor: null,
      firstname: "",
      lastname: "",
      university: "",
      following: false,
      followers: 0,
      update: 0,
      isCurrentUser: false,
      posts: [],
      changeUser: 0,
      loading: true,
      userUsername: "",
      rate: "",
      TutorName: "Tutor",
      courses: [],
      tutorr: "",
      rating: 0,
      likesCount: 0,
      approvesCount: 0,
      user2: null,
      counter: []
    };
  },
  computed: {
    ...mapState([
      "tutor_previewed",
      "filler_img",
      "session_previewed",
      "class_previewed",
    ]),
    ...mapGetters(["getTutorCourseMeta"]),
    tutorCourseMeta() {
      this.tutorr = this.getTutorCourseMeta(this.tutor_previewed);
      // return this.getTutorCourseMeta(this.tutor_previewed);
    },
  },
  mounted() {
    this.userUsername = this.$route.params.username;
    return this.load();
  },
  ionViewWillEnter() {
    this.load();
  },
  methods: {
    ...mapActions(["get_tutor"]),
    ...mapMutations(["SetSessionPreviewClass", "setTutorPreviewed"]),
   load() {
    this.get_tutor(this.$route.params.username).then(async () => {
      this.tutor = this.tutor_previewed;
      this.user = this.tutor_previewed.user;
      this.rate = this.tutor.rate + "";
      this.courses = this.tutor.courses;
      const ratings = this.tutor.courses.map((course) => course.rating).filter((rating) => rating > 0) ?? [];
      this.rating = ratings.reduce((a, b) => (a + b), 0) / ratings.length;
      await this.getTutorProfile()
    });
   },
    book() {
      if (this.class_previewed) {
        const course = this.class_previewed.courses.filter(
          (course) => course.tutor._id == this.tutor_previewed._id
        )[0];
        this.SetSessionPreviewClass(course);
        this.$router.push(
          `/tutor/${this.userUsername}/book/time`
        );
      } else
        this.$router.push(
          `/tutor/${this.userUsername}/book/class`
        );
    },
    async setUser() {
      await get_tutor(this.$route.params.username, true).then(data => {
        this.user = data;
        this.getTutorProfile()
      })
    },
    // async setTutor() {
    //   await this.get_tutor(this.$route.params.username)
    //   this.tutor = this.tutor_previewed;
    //   this.rate = this.tutor_previewed.rate + "";
    //   this.courses = this.tutor.courses;
    //   this.getTutorProfile()
    // },

    async getTutorProfile() {
      await getProfileByUsername(this.userUsername).then(({ data }) => {
        this.user2 = data.user_profile
        this.posts = data.user_posts.data
        this.counter = data.counters.likes_and_approves
        this.likesCount = this.counter.likes
        this.approvesCount = this.counter.approves
      })
      this.loading = false
    },

    // getting posts of a specific user
    // async getPosts() {
    //   await GetPostsByUsername(this.userUsername).then(({data}) => {
    //     this.posts = data.data;
    //     this.posts.reverse();
    //     this.posts = this.posts.filter(post => !post.isAnonymous);
    //   })
    //   this.loading = false;
    // },
  },
  watch: {
    "$route.params.username": {
      handler: function () {
        if (this.$route.params.username) {
          // this.user = this.$store.state.user

        } else this.load();

        this.changeUser++;
      },
      deep: true,
      immediate: true,
    },
  },

}

</script>

<style lang="ts" scoped>

</style>